module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "profile-header",
    class: {
      noidea: !_vm.hasIdea
    },
    style: ('background-image: url(' + _vm.background + ');')
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "image-circle"
  }, [(_vm.user.profileimg === 'default') ? _c('img', {
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.user.profileimg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.surname))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.user.jobtitle)), _c('br'), _vm._v(_vm._s(_vm.user.organisation))]), _vm._v(" "), _c('h4', [_vm._v("Based in " + _vm._s(_vm.user.location))]), _vm._v(" "), (_vm.currentUser) ? _c('router-link', {
    staticClass: "btn btn-round green",
    attrs: {
      "to": {
        name: 'Edit Profile',
        params: {
          area: 'user-meta'
        }
      }
    }
  }, [_vm._v("Edit Profile")]) : _vm._e(), _vm._v(" "), (!_vm.currentUser) ? _c('a', {
    staticClass: "btn btn-round green",
    on: {
      "click": _vm.openChat
    }
  }, [_vm._v("Chat To " + _vm._s(_vm.user.firstname))]) : _vm._e(), _vm._v(" "), (!_vm.currentUser) ? _c('a', {
    staticClass: "btn-star",
    class: {
      active: _vm.isFavourited
    },
    on: {
      "click": _vm.favouriteUser
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.currentUser) ? _c('a', {
    staticClass: "btn-more",
    on: {
      "click": _vm.openOptions
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _c('span', {
    staticClass: "circle"
  }), _c('span', {
    staticClass: "circle"
  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasIdea) ? _c('div', {
    staticClass: "col-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.bigidea))]), _vm._v(" "), (_vm.currentUser) ? _c('router-link', {
    staticClass: "btn btn-round green",
    attrs: {
      "to": {
        name: 'Edit Profile',
        params: {
          area: 'big-idea'
        }
      }
    }
  }, [_vm._v("Edit Big Idea")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Member since " + _vm._s(_vm.userJoined))])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-5"
  }, [(_vm.focusAreas) ? _c('h4', [_vm._v("Focus Area:")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.focusAreas), function(item, key) {
    return _c('focus-area', {
      key: key,
      attrs: {
        "itemid": key
      }
    })
  })), _vm._v(" "), (_vm.countries) ? _c('h4', {
    staticClass: "padding-top"
  }, [_vm._v("Regions of interest:")]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.countries), function(item, key) {
    return _c('country', {
      key: key,
      attrs: {
        "itemid": key
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 shift-1"
  }, [_c('div', {
    staticClass: "skills-subsection"
  }, [(_vm.wantSkills) ? _c('h4', [_vm._v("Skills " + _vm._s(_vm.user.firstname) + " is looking for:")]) : _vm._e(), _vm._v(" "), (_vm.wantSkills) ? _c('div', {
    staticClass: "skills-holder"
  }, [_c('div', {
    staticClass: "skills-wrapper"
  }, [_c('slider', {
    attrs: {
      "data": _vm.wantSkills
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "skills-subsection"
  }, [(_vm.hasSkills) ? _c('h4', [_vm._v("Skills " + _vm._s(_vm.user.firstname) + " has:")]) : _vm._e(), _vm._v(" "), (_vm.hasSkills) ? _c('div', {
    staticClass: "skills-holder"
  }, [_c('div', {
    staticClass: "skills-wrapper"
  }, [_c('slider', {
    attrs: {
      "data": _vm.hasSkills
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), (!_vm.currentUser) ? _c('section', {
    staticClass: "profile-chat"
  }, [_c('div', {
    staticClass: "grid-inner"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "chat-box",
    class: {
      active: _vm.chatActive
    }
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": _vm.toggleChat
    }
  }, [_c('div', {
    staticClass: "image-circle"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.profileimg
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "online"
  }, [_vm._v("Chat to " + _vm._s(_vm.user.firstname))])]), _vm._v(" "), _c('chat', {
    attrs: {
      "chats": _vm.chats,
      "userid": this.$route.params.uid
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message",
    attrs: {
      "type": "text",
      "placeholder": "Type a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.send($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showOptionsOverlay) ? _c('section', {
    staticClass: "overlay-dialogue binary",
    on: {
      "click": _vm.closeOptions
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-align"
  }, [_c('h4', [_vm._v("Would you like to block or report " + _vm._s(_vm.user.firstname) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round red",
    on: {
      "click": _vm.blockUser
    }
  }, [_vm._v("Block " + _vm._s(_vm.user.firstname))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round red",
    on: {
      "click": _vm.blockAndReportUser
    }
  }, [_vm._v("Block & Report")])])])]) : _vm._e(), _vm._v(" "), (_vm.showBlockOverlay) ? _c('block-report', {
    attrs: {
      "userid": this.$route.params.uid,
      "firstname": _vm.user.firstname,
      "surname": _vm.user.surname
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ea2b9b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UserProfile.vue
// module id = 724
// module chunks = 1